import React from 'react';
import { ModalTransition as AKModalTransition } from '@atlaskit/modal-dialog';
import { isReducedMotion } from '@atlaskit/motion';
import { useMinimizableModal } from '../../../controllers/use-minimizable-modal/index.tsx';
import { TransitionState } from '../../../controllers/use-minimizable-modal/types.tsx';
import type { ModalTransitionProps } from './types.tsx';

export const ModalTransition = ({
	children,
	renderCondition,
}: ModalTransitionProps): React.JSX.Element | null => {
	const { isTransitionInState } = useMinimizableModal();

	if (isReducedMotion()) {
		if (renderCondition) {
			return <>{children}</>;
		}
		return null;
	}

	const shouldRenderModalView =
		renderCondition && isTransitionInState(['mini', 'minimized'], TransitionState.EXITED);

	return <AKModalTransition>{shouldRenderModalView && children}</AKModalTransition>;
};
